<template>
  <section class="admin-header mar-l-30 mar-r-30">
    <div class="logo-box">
      <div class="logo-box mar-r-30">
        <a href="http://www.paohe.cn"
           target="_blank"
           class="logo">
          <img src="../assets/admin-logo.png"
               alt="跑合网" />
        </a>
        <router-link to="/manage/dashboard"
                     class="mar-r-20">
          <div class="logo-info mar-r-30 pad-l-15">文山三七拍卖中心</div>
        </router-link>
      </div>
    </div>
    <div class="header-right">
      <ul>
        <router-link v-if="filterFunctions.includes('xxgl-xxgl')"
                     to="/manage/messageManageList"
                     class="mar-r-20">
          <i class="iconfont icon-f-fankui mar-r-5"></i>消息
        </router-link>
        <a @click="logout()"><img src="@/assets/ico_over.png"
               alt=""
               class="mar-r-5"
               style="vertical-align: middle;">退出</a>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'adminHeader',
  created () {
    if (localStorage.functions.length > 0) {
      this.functions = JSON.parse(localStorage.functions)
      this.functions.forEach(item => {
        if (item.functionCode) {
          this.filterFunctions.push(item.functionCode)
        }
      })
    }
  },
  data () {
    return {
      functions: [],//原菜单
      filterFunctions: []//过滤后菜单
    }
  },
  computed: {
    //当前用户
    /*user(){
      return JSON.parse(localStorage.getItem('userInfo')).userName;
    }*/
  },
  methods: {
    logout () {
      //定义token退出值
      localStorage.removeItem("token");//清除token
      localStorage.removeItem("userInfo");//清除userName
      this.$store.dispatch("clearCurrentState");//清空vuex状态
      this.$router.push("/login");//跳转
    },
  }
}
</script>

<style lang="less">
.admin-header {
  display: flex;
  padding: 18px 0;
  align-content: center;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  .logo-box {
    display: flex;
    align-content: center;
    align-items: center;
    .logo {
      display: block;
      width: 72px;
      height: 23px;
    }
    .logo-info {
      font-size: 18px;
      font-weight: bold;
      color: #ab5d01;
      line-height: 1;
    }
  }
  .search-wrapper {
    margin: 0 auto;
    height: 36px;
    line-height: 36px;
    overflow: hidden;
    .search-form {
      overflow: hidden;
    }
    .search-input {
      float: left;
      width: 234px;
      height: 36px;
      line-height: 36px;
      input {
        height: 36px;
        line-height: 36px;
        border-radius: 0;
      }
    }
    .search-btn {
      float: left;
      width: 36px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      background: #ddd;
      border: 1px solid #ccc;
      border-left: 0;
      &:hover {
        background: #eee;
        cursor: pointer;
      }
      .iconfont {
        font-size: 20px;
        color: #999;
      }
    }
  }
  .header-right {
    display: flex;
    .list-item {
      display: inline-block;
      font-size: 13px;
      cursor: pointer;
      height: 36px;
      line-height: 36px;
      color: #666;
      &:hover {
        color: #ab5d01;
      }
      &.router-link-exact-active {
        color: #ab5d01;
      }
      .iconfont {
        display: inline-block;
        font-size: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AdminHeader.vue